let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jvuhr"), load("jdHbV"), load("3VLKz"), load("jwSno"), load("c6Kww"), load("4sZyu")]).then(() => parcelRequire('3iK0z'));